import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.9111 6.66335L14.2095 7H14.6594H18C19.1046 7 20 7.89543 20 9V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H7H10.6504C11.2226 4 11.7674 4.2451 12.147 4.6733L13.9111 6.66335Z" stroke="#585858" stroke-width="2"/>
      <path d="M13 15C12.4477 15 12 15.4477 12 16C12 16.5523 12.4477 17 13 17H16C16.5523 17 17 16.5523 17 16C17 15.4477 16.5523 15 16 15H13Z" fill="#585858"/>
    </svg>
  );
};

export default Svg;
